module.exports = __webpack_public_path__ + "assets/img/arrow.6cf9329b.svg";